import $ from "jquery";
import "@babel/polyfill";
import Foundation from "./_foundation";
import "motion-ui/dist/motion-ui";
import AOS from "aos";
import throttle from "lodash/throttle";
import "../../node_modules/jquery-parallax.js/parallax.min.js";
import inlineSVG from "./_inline-svg";
import {
  lazyImages,
  lazyBackgrounds,
  lazyVideos,
  lazyOembeds,
  lazyInterchange,
} from "./_lazy-load";
import { smoothScrollOnPageLoad } from "./_smoothScrollOnPageLoad";
import "./_skip-link-focus-fix";
import "./_acf-map";
import "./_fixed-header";
import "./_header-height";
import "./_hero-slider";
import "./_notification";
import "./_scroll-to-top";
import "./_slick";
import "./_off-canvas";
import "./_faqs_accordion";
// import './_fragmentURLs'
/* Additional Scripts */
// import { randomString } from './_random-string'
import "./_ie";
import "./focus-visible.min.js";

// Foundation
$(document).foundation();

// Inline SVG
inlineSVG();

// Smooth Scroll on page load
smoothScrollOnPageLoad();

// Lazy-load on DOMContentLoaded
window.addEventListener(
  "DOMContentLoaded",
  function () {
    lazyImages();
    lazyBackgrounds();
    lazyVideos();
    lazyOembeds();
    lazyInterchange();
  },
  false
);

// Lazy-load on scroll event
window.addEventListener("scroll", throttle(lazyImages, 75), { passive: true });
window.addEventListener("scroll", throttle(lazyBackgrounds, 75), {
  passive: true,
});
window.addEventListener("scroll", throttle(lazyOembeds, 75), { passive: true });
window.addEventListener("scroll", throttle(lazyInterchange, 75), {
  passive: true,
});

// AOS
AOS.init();

// Desktop Search Bar
$(".js-search-toggle").click(function (e) {
  e.preventDefault();

  $(".js-search-form").css("visibility", "visible").animate(
    {
      width: "100%",
      opacity: 1,
      left: 0,
    },
    500
  );
});

$(".js-search-close").click(function (e) {
  e.preventDefault();

  $(".js-search-form")
    .animate(
      {
        width: "0%",
        opacity: 0,
      },
      500
    )
    .delay(500)
    .css({ visibility: "hidden" });
});

// Fix FontAwesome Icons
$(".fab").each(function (i, v) {
  if ($(v).hasClass("fa")) {
    $(v).removeClass("fa");
  }
});

$(".mega-menu").each(function (i, v) {
  $(".site-navigation__nav")
    .find("." + $(this).data("attachment"))
    .attr("data-attachment", $(this).data("attachment"));
});

$('li[class^="megamenu"]')
  .mouseover(function () {
    let attachment = $(
      'div[data-attachment="' + $(this).data("attachment") + '"]'
    );

    attachment.show();
  })
  .mouseleave(function () {
    let attachment = $(
      'div[data-attachment="' + $(this).data("attachment") + '"]'
    );

    attachment.hide();
  });

$('div[class^="mega-menu"] .grid-x').mouseover(function () {
  let attachment = $(this).parent().parent();

  attachment.show();
});

$('div[class^="mega-menu"] .grid-x').mouseleave(function () {
  let attachment = $(this).parent().parent();

  attachment.hide();
});

// Hero Menu Hovers
$("[data-color]").hover(
  function () {
    $(this).css("background-color", $(this).data("color"));
  },
  function () {
    $(this).css("background-color", "white");
  }
);

// Position Testimonial Arrows
if ($(".js-testimonial").length > 0) {
  let elementWidth =
    parseInt(
      $(".js-testimonial .slick-slide:first-of-type .grid-container")
        .css("marginLeft")
        .replace("px", "")
    ) +
    parseInt(
      $(".js-testimonial .slick-slide:first-of-type .grid-container .cell")
        .css("marginLeft")
        .replace("px", "")
    ) +
    15;
  $(".js-testimonial .slick-prev").css("left", elementWidth);
  $(".js-testimonial .slick-next").css("left", elementWidth + 36);

  $(window).resize(function () {
    elementWidth =
      parseInt(
        $(".js-testimonial .slick-slide:first-of-type .grid-container")
          .css("marginLeft")
          .replace("px", "")
      ) +
      parseInt(
        $(".js-testimonial .slick-slide:first-of-type .grid-container .cell")
          .css("marginLeft")
          .replace("px", "")
      ) +
      15;
    $(".js-testimonial .slick-prev").css("left", elementWidth);
    $(".js-testimonial .slick-next").css("left", elementWidth + 36);
  });
}

// Filter
if ($(".js-filter").length > 0) {
  $(".js-filter").on("change", function () {
    if ($(this).val() !== "*") {
      $(".filter-container")
        .not('[data-filter*="' + $(this).val() + '"]')
        .fadeOut();
      $('.filter-container[data-filter*="' + $(this).val() + '"]').fadeIn();
    } else {
      $(".filter-container").fadeIn();
    }
  });
}

$(".fixed-newsletter .close").on("touchstart click", function () {
  $(".fixed-newsletter").fadeOut();
});

$(".fixed-newsletter a").on("touchstart click", function () {
  Cookies.set("fixed-newsletter", 1, { expires: 365 });
});

function equalHeights(selector) {
  if ($(selector).length <= 0) {
    return false;
  } else {
    $(selector).css("height", "auto");
  }

  var el = selector;
  var newHeight = "";
  var colHeights = [];

  $(el).each(function () {
    var singleCol = $(this).outerHeight(); // Get the outerHeight of a single column
    colHeights.push(singleCol); // Push the single height into the array
    newHeight = Math.max.apply(Math, colHeights); // Get the tallest column from the array
  });
  $(el).css("height", newHeight + "px"); // Apply the tallest height to all columns

  return true;
}

equalHeights(".site-hero__menu li a");

/**
 * Use datepicket in GF List column.
 * @url https://community.gravityforms.com/t/date-field-in-list/826/2
 */

// Form ID - 13 (Nightstop Volunteer Form)
// Field ID - 32
// Column number - 4 (Date of Birth)

function listFieldDatepicker(formId, fieldId, column) {
  var listField = "#field_" + formId + "_" + fieldId,
    columnClass = ".gfield_list_" + fieldId + "_cell" + column + " input";
  jQuery.datepicker.setDefaults({
    showOn: "both",
    buttonImage: "/wp-content/plugins/gravityforms/images/calendar.png",
    buttonImageOnly: true,
    dateFormat: "dd/mm/yy",
    firstDay: 1,
  });
  jQuery(columnClass).css({ width: "80%", "margin-right": "2px" }).datepicker();
  jQuery(listField).on("click", ".add_list_item", function () {
    jQuery(".ui-datepicker-trigger").remove();
    jQuery(columnClass)
      .removeClass("hasDatepicker")
      .removeAttr("id")
      .datepicker();
  });
}
listFieldDatepicker(13, 32, 4);

// @url https://docs.gravityforms.com/gform_datepicker_options_pre_init/

gform.addFilter(
  "gform_datepicker_options_pre_init",
  function (optionsObj, formId, fieldId) {
    // do stuff

    return optionsObj;
  }
);

jQuery(".custom-block .accordion-item").click(function () {
  console.log("s");
  $(this).next(".accordion-content").slideToggle().toggleClass("active");
  $(this).toggleClass("active");
});
